<ng-container *ngIf="!item.hidden">
  <!-- item.url -->
  <a
    class="dropdown-item d-flex align-items-center"
    [ngClass]="item.classes"
    *ngIf="item.url && !item.externalUrl && !item.disabled"
    [routerLink]="[item.url]"
    [target]="item.openInNewTab ? '_blank' : '_self'"
  >
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>

  <!-- item.externalUrl -->
  <a
    class="dropdown-item d-flex align-items-center"
    [ngClass]="item.classes"
    *ngIf="item.url && item.externalUrl && !item.disabled"
    [href]="item.url"
    [target]="item.openInNewTab ? '_blank' : '_self'"
  >
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>

  <!-- disabled item or item without url -->
  <a
    class="dropdown-item d-flex align-items-center disabled"
    [ngClass]="item.classes"
    *ngIf="item.disabled || !item.url"
    style="pointer-events: none; opacity: 0.5; cursor: not-allowed;"
  >
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>

  <ng-template #itemContent>
    <!-- <span [data-feather]="item.icon" *ngIf="item.icon"></span> -->
    <lucide-angular
      *ngIf="item.icon"
      [name]="item.icon"
      size="20"
    ></lucide-angular>
    <span [translate]="item.translate">{{ item.title }}</span>
  </ng-template>
</ng-container>
